<template>
  <div class="mod mod-success">
    <div>
      <p>您的预约已提交成功，如航班开航，祥鹏航空将通知您进行航班预定，请您注意查收短信。</p>
    </div>
    <div class="action">
      <a-button class="full-btn" size="large" type="primary" @click="onBack">我知道了</a-button>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    onBack () {
      history.go(-1)
    }
  }
}
</script>
